import { render, staticRenderFns } from "./Person_academic_degree.vue?vue&type=template&id=1f8ad4e8&scoped=true"
import script from "./Person_academic_degree.vue?vue&type=script&lang=js"
export * from "./Person_academic_degree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ad4e8",
  null
  
)

export default component.exports